export let ACTIVE_CURRENCY = {
  currency: 'USD',
  conversion_rate: 1,
  symbol: '$',
}
export const CURRENCY = [
  {
    name: 'AED',
    symbol: 'AED',
    display: 'United Arab Emirates Dirham',
  },
  {
    name: 'USD',
    symbol: '$',
    display: 'United States Dollar',
  },
  {
    name: 'INR',
    symbol: '₹',
    display: 'Indian Rupee',
  },
]
export const currencyMap = CURRENCY.reduce((obj: any, prop: any) => {
  obj[prop.name] = prop
  return obj
}, {}) as any
export function localizeFiat(number: number | string, conversionRates?: Record<string, number>) {
  /** if conversionRates is not passed, it will use the current conversionRates */
  let currentCurrencyConversionRate = ACTIVE_CURRENCY.conversion_rate
  if (!conversionRates) {
    currentCurrencyConversionRate = ACTIVE_CURRENCY.conversion_rate
  } else {
    currentCurrencyConversionRate = conversionRates[ACTIVE_CURRENCY.currency]
  }

  if (typeof number === 'string') {
    number = Number(number)
  }
  return ACTIVE_CURRENCY.symbol + '' + (currentCurrencyConversionRate * number).toFixed(2)
}

export function heroBalance(number: number | string) {
  if (number === undefined) return { localValue: '-', usdValue: '-' }
  if (typeof number === 'string') {
    number = Number(number)
  }
  const localValue = ACTIVE_CURRENCY.symbol + ' ' + (ACTIVE_CURRENCY.conversion_rate * number).toFixed(2) || ACTIVE_CURRENCY.symbol + ' 0.00'
  if (ACTIVE_CURRENCY.symbol !== '$') {
    const usdValue = '$ ' + Number(number).toFixed(2)
    return { localValue, usdValue }
  }
  return { localValue, usdValue: null }
}

const MILLION = 10 ** 6
export default function AmountToWord(amount: string | number) {
  if (typeof amount === 'string') {
    amount = Number(amount)
  }
  if (amount >= MILLION) {
    return localizeFiat(amount / MILLION) + 'M'
  }
  return localizeFiat(amount)
}
